var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 35,
    viewBox: "0 0 29 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1625 33.04C22.2888 34.8564 20.2429 34.5696 18.2735 33.7092C16.1894 32.8297 14.2773 32.7914 12.0785 33.7092C9.32515 34.8947 7.872 34.5505 6.22765 33.04C-3.10309 23.4224 -1.72642 8.77625 8.86626 8.24088C11.4475 8.37472 13.2448 9.65578 14.7553 9.7705C17.0115 9.31162 19.1721 7.99231 21.5813 8.16439C24.4685 8.39384 26.6482 9.54106 28.0822 11.6061C22.1167 15.1816 23.5316 23.04 29 25.2389C27.9101 28.1069 26.4952 30.9559 24.1434 33.0591L24.1625 33.04ZM14.5641 8.12615C14.2773 3.86231 17.7381 0.344167 21.7151 0C22.2696 4.93305 17.241 8.60416 14.5641 8.12615Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/AndroidIcon.ca38474ce3fce72204a219aede3c2e27.svg";
export { ForwardRef as ReactComponent };